import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { locationShape } from 'react-router/lib/PropTypes';
import URI from 'urijs';
import _ from 'lodash';

import OrderActions from '../../actions/OrderActions';
import connectToStores from '../../helpers/connectToStores';
import OrderStore from '../../stores/OrderStore';
import OrderHandoff from '../../records/order/Handoff';
import { resolve } from '../../helpers/LinkMapper';
import config from '../../config';

const _getStateFromStores = () => ({
    handoffDetails: OrderStore.getHandoffDetails(),
    isHandoffReported: OrderStore.getHandoffReferralReported(),
});

class NREReferralFrame extends Component {
    componentDidMount() {
        const { search } = this.props.location;

        /**
         * Booking Engine does some parsing to query string before it's accessible in location object.
         * Because of that, there are 3 steps needed to decode query and turn it into usable object.
         * 1. JS .decodeURIComponent() decodes characters like %3b => ;
         * 2. lodash .unescape() that turns &amp; into &
         * 3. first argument has broken and unnecesary symbol ?amp; - .replace() takes care of that
         */
        const query = URI.parseQuery(_.unescape(decodeURIComponent(search)).replace('amp;', ''));
        const orderHandoff = resolve(query).as(OrderHandoff);

        if (orderHandoff.handoffid) {
            OrderActions.updateHandoffDetails(orderHandoff);
        }
    }

    componentWillUnmount() {
        OrderActions.updateHandoffReferralReported(true);
    }

    render() {
        const { handoffDetails, isHandoffReported } = this.props;

        if (isHandoffReported === true || !handoffDetails || !handoffDetails.handoffid) {
            return null;
        }

        const isProd = config.get('environment') === 'prod';
        const baseUrl = config.get(isProd ? 'journeyPlannerNREUrl' : 'journeyPlannerNREStagingUrl');
        const queryString = `?${handoffDetails.getReferralQueryString()}`;
        const url = `${baseUrl}/service/iframe/error${queryString}`;

        return (
            <iframe src={url} width={1} height={1} frameBorder={0} style={{ display: 'none' }} />
        );
    }
}

NREReferralFrame.propTypes = {
    location: locationShape,
    handoffDetails: PropTypes.instanceOf(OrderHandoff),
    isHandoffReported: PropTypes.bool,
};

export default connectToStores([OrderStore], _getStateFromStores)(NREReferralFrame);



// WEBPACK FOOTER //
// ./src/components/nre/ReferralFrame.js